// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICensusIncomingRecordDto } from './ICensusIncomingRecordDto';
import {
    ICensusIncomingRecordDtoFromJSON,
    ICensusIncomingRecordDtoFromJSONTyped,
    ICensusIncomingRecordDtoToJSON,
    ICensusIncomingRecordDtoToJSONTyped,
} from './ICensusIncomingRecordDto';

/**
 * 
 * @export
 * @interface ICensusRequestBatchDto
 */
export interface ICensusRequestBatchDto {
    /**
     * 
     * @type {string}
     * @memberof ICensusRequestBatchDto
     */
    census_id: string;
    /**
     * 
     * @type {Array<ICensusIncomingRecordDto>}
     * @memberof ICensusRequestBatchDto
     */
    records?: Array<ICensusIncomingRecordDto>;
}

/**
 * Check if a given object implements the ICensusRequestBatchDto interface.
 */
export function instanceOfICensusRequestBatchDto(value: object): value is ICensusRequestBatchDto {
    if (!('census_id' in value) || value['census_id'] === undefined) return false;
    return true;
}

export function ICensusRequestBatchDtoFromJSON(json: any): ICensusRequestBatchDto {
    return ICensusRequestBatchDtoFromJSONTyped(json, false);
}

export function ICensusRequestBatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusRequestBatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'census_id': json['census_id'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(ICensusIncomingRecordDtoFromJSON)),
    };
}

export function ICensusRequestBatchDtoToJSON(json: any): ICensusRequestBatchDto {
    return ICensusRequestBatchDtoToJSONTyped(json, false);
}

export function ICensusRequestBatchDtoToJSONTyped(value?: ICensusRequestBatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'census_id': value['census_id'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(ICensusIncomingRecordDtoToJSON)),
    };
}

